var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top"},[(_vm.$store.state.backBtnVisible)?_c('backBtn'):_vm._e(),(!_vm.$store.state.backBtnVisible)?_c('searchBar'):_vm._e(),_c('userInfo',{staticClass:"info"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }